import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { USD_CURRENCY_CODE } from '@constants/constants';
import { isNullOrUndefinedOrEmpty } from '@utils/common';
import { toggleButtonStyles, toggleGroupStyles } from './styles';

export type CurrencyToggleProps = {
  selectedCurrency: string;
  value: string;
  onChange: (currency: string) => void;
  isLoading?: boolean;
};

const CurrencyToggle = ({ selectedCurrency, value, onChange, isLoading }: CurrencyToggleProps) => {
  if (isLoading || isNullOrUndefinedOrEmpty(selectedCurrency)) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
      <ToggleButtonGroup
        value={value}
        exclusive
        sx={toggleGroupStyles}
        onChange={(_, newCurrency: string | null) => {
          if (newCurrency !== null) onChange(newCurrency);
        }}
      >
        <ToggleButton value={selectedCurrency} sx={toggleButtonStyles}>
          <Typography sx={{ fontWeight: 700, color: '#6C6C6C', fontSize: '0.875rem' }}>
            {selectedCurrency}
          </Typography>
        </ToggleButton>
        <ToggleButton value={USD_CURRENCY_CODE} sx={toggleButtonStyles}>
          <Typography sx={{ fontWeight: 700, color: '#6C6C6C', fontSize: '0.875rem' }}>
            {USD_CURRENCY_CODE}
          </Typography>
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default CurrencyToggle;
